<div class="row header d-flex justify-content-between">
  <div class="col-auto d-flex flex-wrap align-items-center">
		<a routerLink="/dashboard"><img class="main-image" alt="" src="../../../assets/images/logo-primary.svg"></a>
  </div>
  <div class="col-auto">
    <div class="float-end m-2 user-profile">
      <a routerLink="/user/user_detail"><img class="rounded-circle" height="40" [src]="userImg" width="40"></a>
    </div>
    <div class="language-dd m-2">
      <select (change)="changeLanguage($event)" [(ngModel)]="currentLang" class="form-select" name="currentLang">
        <option selected value="en">EN</option>
        <option value="es">ES</option>
      </select>
    </div>
  </div>
</div>
